import { cn } from '@exam-room/utils';

export interface SummaryStatsCardProps {
  title: string;
  displayValue: string;
  variant?: 'success' | 'error' | 'info' | 'warning';
}

const getCardVariant = (
  variant: 'success' | 'error' | 'info' | 'warning' | 'default' = 'default',
) => {
  const colorMapping = {
    error: {
      backgroundColor: 'bg-danger-100',
      titleAndInfoColor: 'text-danger-700',
      displayColor: 'text-danger-700',
    },
    success: {
      backgroundColor: 'bg-success-100',
      titleAndInfoColor: 'text-success-700',
      displayColor: 'text-success-700',
    },
    info: {
      backgroundColor: 'bg-info-100',
      titleAndInfoColor: 'text-info-700',
      displayColor: 'text-info-700',
    },
    warning: {
      backgroundColor: 'bg-warning-100',
      titleAndInfoColor: 'text-warning-700',
      displayColor: 'text-warning-700',
    },
    default: {
      backgroundColor: 'bg-grey-100',
      titleAndInfoColor: 'text-text-primary',
      displayColor: 'text-text-primary',
    },
  };

  return colorMapping[variant] ?? colorMapping.default;
};

export default function SummaryStatsCard(props: Readonly<SummaryStatsCardProps>) {
  const { title, displayValue, variant } = props;

  const { backgroundColor, titleAndInfoColor, displayColor } = getCardVariant(variant);

  return (
    <div className={cn(backgroundColor, 'flex-1 gap-4 rounded-lg p-4')}>
      <div className='flex flex-1 flex-col gap-1'>
        <span className={cn(titleAndInfoColor, 'w-full')}>{title}</span>
        <div className='flex items-baseline gap-1'>
          <h3 className={cn(displayColor, 'w-full')}>{displayValue}</h3>
        </div>
      </div>
    </div>
  );
}
